import { EventEmitter } from '@angular/core';

import { each, find } from 'lodash';

import {
  IComponentStateHistory,
  IValueChangedEvent,
  IWizardContentComponent
} from '../../../wizard.content';

export class RadioOptionsComponent implements IWizardContentComponent {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  step: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  subStep: any;
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  wizardCtrl: any;
  componentId: string;
  stateHistory?: IComponentStateHistory;
  onDataValueChange: EventEmitter<IValueChangedEvent> = new EventEmitter();
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  radioOptions: any = [];
  key: string;

  mustBePresented(): boolean {
    return true;
  }

  // only updates selection states of radio options, does not try to emit any notifications
  // to outside.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  setSelectionTo(selection: any): void {
    each(this.radioOptions, element => {
      if (element.internalValue === selection) {
        element.selected = true;
      } else {
        element.selected = false;
      }
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  _onClick(optionInternalValue: any): void {
    this.setSelectionTo(optionInternalValue);
    const value = this._makeOutput();
    this.onDataValueChange.emit({
      componentId: this.componentId,
      key: this.key,
      newValue: value,
      isValid: value ? true : false
    });
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  _makeOutput(): any {
    //eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectedOption: any = find(this.radioOptions, { selected: true });
    if (selectedOption) {
      return selectedOption.internalValue;
    }
    return null;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  translateLabel(label: any): any {
    return label;
  }
}
